import { render, staticRenderFns } from "./energyConsumptByZone.vue?vue&type=template&id=672ebe8e&scoped=true"
import script from "./energyConsumptByZone.vue?vue&type=script&lang=js"
export * from "./energyConsumptByZone.vue?vue&type=script&lang=js"
import style0 from "./energyConsumptByZone.vue?vue&type=style&index=0&id=672ebe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ebe8e",
  null
  
)

export default component.exports